<template>
  <v-container id="calculo-extraordinario" fluid>
    <v-row>
      <v-col cols="12" md="4">
        <v-select v-model="contacto_id" color="gold" :items="contactos" item-value="id" label="Contacto" :item-text="item =>` ${item.nombre}`">
          <template v-slot:item="{ attrs, item, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="contactoText(item)" />
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:append-outer>
            <v-btn elevation="1" color="success" fab x-small @click="mostrarContactoForm = true">
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select v-model="moneda_id" :items="monedas" label="Moneda" item-value="id" item-text="descripcion" />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field v-model="monto" color="gold" type="number" step="0.01" :prefix="simboloMoneda" label="Total a pagar" :disabled="bloquear" />
      </v-col>
    </v-row>
    <contactos-form :show="mostrarContactoForm" @update="getContactos" @close="mostrarContactoForm = false" />
  </v-container>
</template>

<script>
  import ContactosForm from '../altas/ContactosForm'
  export default {
    name: 'CalculoExtraordinario',
    components: {
      ContactosForm,
    },
    props: {
      toggleReset: {
        type: Boolean,
        required: false,
        default: false,
      },
      monedas: {
        type: Array,
        default: function () {
          return []
        },
        required: false,
      },
      bloquear: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        mostrarContactoForm: false,
        contactos: [],
        moneda_id: 1,
        monto: 0,
        contacto_id: 0,
        typingTimer: {},
      }
    },
    computed: {
      simboloMoneda () {
        return (this.monedas.length !== 0) ? this.monedas.find(e => e.id === this.moneda_id).simbolo : '$'
      },
    },
    watch: {
      toggleReset () {
        this.contacto_id = 0
        this.monto = 0
      },
      moneda_id () {
        this.enviarPadre()
      },
      monto () {
        clearTimeout(this.typingTimer)
        this.typingTimer = setTimeout(() => this.acomodarMonto(), 1500)
      },
      contacto_id () {
        this.$emit('reset')
        this.enviarPadre()
      },
    },
    created () {
      this.getContactos()
    },
    methods: {
      acomodarMonto () {
        this.monto = parseFloat(this.monto)
        if (this.monto < 0) {
          this.monto = (this.monto * -1)
          this.$store.commit('toast/show', { tipo: 'info', messages: ['El monto debe ser una valor positivo.'] })
        }
        this.enviarPadre()
      },
      enviarPadre () {
        const datos = {
          totalAPagar: this.monto,
          monedaId: this.moneda_id,
          objetoPago: this.contacto_id,
          caso: 'Proveedor',
        }
        this.$emit('montoGenerado', datos)
      },
      getContactos: async function (idContacto) {
        this.mostrarContactoForm = false // esto no se hace XD
        this.$store.dispatch('axiosMod/getData', { url: '/api/contactos' }).then(response => {
          this.contactos = response
          if (idContacto !== 0) {
            this.contacto_id = idContacto
          } else if (this.contactos.length !== 0) {
            this.contacto_id = this.contactos[0].id
          }
        })
      },
      contactoText (item) {
        const rs = item.razon_social
        if (rs !== null) {
          return item.nombre + ' - ' + rs
        }
        return item.nombre
      },
    },
  }
</script>
